import ClientAccountValidation from '../components/ClientAccountValidation.svelte';
import RequestHistoryButton from '../components/RequestHistoryButton.svelte';
import AttachmentCard from '../components/AttachmentCard.svelte';
import BulkRequests from '../components/BulkRequests.svelte';
import BulkResponse from '../components/BulkResponse.svelte';
import BulkComplaints from '../components/BulkComplaints.svelte';
import BulkRecoveries from '../components/BulkRecoveries.svelte';
import BulkClosure from "../components/BulkClosure.svelte";

// account validation
const accountValidationElement = document.querySelector<HTMLElement>("#clientAccountValidation");
if (accountValidationElement) {
    // dataset
    const props = getElementProps(accountValidationElement);
    new ClientAccountValidation({
        target: accountValidationElement,
        props: {
            _emitMount: true,
            ...props,
            showprice: props['showprice'] === 'True'
        }
    });
}

// request history
const requestHistoryElement = document.querySelector<HTMLElement>("#requestHistoryButton");
if (requestHistoryElement) {
    // dataset
    const props = getElementProps(requestHistoryElement);
    new RequestHistoryButton({
        target: requestHistoryElement,
        props: {
            _emitMount: true,
            accountId: props["accountid"]
        }
    });
}

// attachment card
const attachmentCardElement = document.querySelector<HTMLElement>("#attachmentCards");
if (attachmentCardElement) {
    // dataset
    const props = getElementProps(attachmentCardElement);
    // init component
    new AttachmentCard({
        target: attachmentCardElement,
        props: {
            name: 'attachments',
            ...props,
            uploaded: JSON.parse(props["uploaded"] || '[]'),
            _emitMount: true
        }
    });
}

// Bulk Request
const BulkRequestsElement = document.querySelector<HTMLElement>("#bulkRequestImport");
if (BulkRequestsElement) {
    // dataset
    const props = getElementProps(BulkRequestsElement);
    // init component
    new BulkRequests({
        target: BulkRequestsElement,
        props: {
            name: 'attachments',
            ...props,
            _emitMount: true
        }
    });
}

// Bulk Responses
const BulkResponseElement = document.querySelector<HTMLElement>("#bulkResponseImport");
if (BulkResponseElement) {
    // dataset
    const props = getElementProps(BulkResponseElement);
    // init component
    new BulkResponse({
        target: BulkResponseElement,
        props: {
            name: 'attachments',
            ...props,
            _emitMount: true
        }
    });
}

// Bulk Closure
const BulkClosureElement = document.querySelector<HTMLElement>("#bulkClosureImport");
if (BulkClosureElement) {
    // dataset
    const props = getElementProps(BulkClosureElement);
    // init component
    new BulkClosure({
        target: BulkClosureElement,
        props: {
            name: 'attachments',
            ...props,
            _emitMount: true
        }
    });
}

// Bulk Complaint
const BulkComplaintsElement = document.querySelector<HTMLElement>("#bulkComplaintsImport");
if (BulkComplaintsElement) {
    // dataset
    const props = getElementProps(BulkComplaintsElement);
    // init component
    new BulkComplaints({
        target: BulkComplaintsElement,
        props: {
            name: 'attachments',
            ...props,
            _emitMount: true
        }
    });
}

// Bulk Recoveries
const BulkRecoveriesElement = document.querySelector<HTMLElement>("#bulkRecoveriesImport");
if (BulkRecoveriesElement) {
    // dataset
    const props = getElementProps(BulkRecoveriesElement);
    // init component
    new BulkRecoveries({
        target: BulkRecoveriesElement,
        props: {
            name: 'attachments',
            ...props,
            _emitMount: true
        }
    });
}

function getElementProps(element: HTMLElement) {
    // get slot
    const svelteSlot = element.querySelector<HTMLElement>('.svelte-slot');
    // clone
    const slot = svelteSlot ? svelteSlot.cloneNode(true) : undefined;
    // remove old one
    svelteSlot?.remove();

    return {
        ...element.dataset,
        slot
    };
}
export default undefined;